import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Badge,
  Spinner,
  Alert,
  ListGroup,
  Form,
} from "react-bootstrap";
import { getAuthDetails } from "../constants/helpers";
import { useNavigate } from "react-router-dom";
import { useGetUserByMobileQuery } from "../redux/api/Patients/PatientsApi";

const UserSelectionModal = ({ show, onHide, onUserSelect }) => {
  const navigate = useNavigate();
  const { mobileNumber } = getAuthDetails();
  const { data, error, isLoading } = useGetUserByMobileQuery(
    { mobile: mobileNumber },
    { skip: !mobileNumber }
  );
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    if (!show) {
      setSelectedUser(null);
    }
  }, [show]);

  const handleUserSelect = () => {
    if (selectedUser) {
      onUserSelect(selectedUser);
      onHide();
    }
  };
  const handleAddNewUser = () => {
    onHide();
    navigate("/book-your-appointment");
  };

  const getAgeBadgeVariant = (age) => {
    if (age < 12) return "info";
    if (age < 18) return "primary";
    if (age < 30) return "purple";
    if (age < 50) return "warning";
    return "danger";
  };

  const getGenderBadgeVariant = (gender) => {
    switch (gender.toLowerCase()) {
      case "male":
        return "purple";
      case "female":
        return "info";
      default:
        return "secondary";
    }
  };

  return (
    <>
      <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
        <Modal.Header
          closeButton
          className="bg-purple text-white"
          closeVariant="white"
        >
          <Modal.Title>Select Patient</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "40vh", overflowY: "auto" }}>
          {isLoading ? (
            <div className="text-center my-4">
              <Spinner animation="border" className="text-purple" />
              <p className="mt-2 text-purple">Loading patients...</p>
            </div>
          ) : error ? (
            <Alert variant="danger">
              Failed to fetch users. Please try again later.
            </Alert>
          ) : data?.success && data.count > 0 ? (
            <ListGroup>
              {data.data.map((user) => (
                <ListGroup.Item
                  key={user._id}
                  action
                  active={selectedUser?._id === user._id}
                  onClick={() => setSelectedUser(user)}
                  style={{
                    backgroundColor:
                      selectedUser?._id === user._id ? "#e8f5e9" : "white",
                    border:
                      selectedUser?._id === user._id
                        ? "1px solid #e8f5e9"
                        : "0px solid white",
                  }}
                  className="d-flex justify-content-between align-items-center"
                >
                  <div>
                    <div className="d-flex align-items-center">
                      <h5 className="mb-1 me-2 text-dark">{user.fullName}</h5>
                      <Badge
                        pill
                        bg={getGenderBadgeVariant(user.gender)}
                        className="me-2"
                      >
                        {user.gender}
                      </Badge>
                      <Badge pill bg={getAgeBadgeVariant(user.age)}>
                        {user.age} years
                      </Badge>
                    </div>
                    <p className="mb-1 text-muted">
                      {user.area && user.city ? (
                        <>
                          {user.area}, {user.city} | Lab Patient ID:{" "}
                          {user.labPatientId}
                        </>
                      ) : (
                        <>Lab Patient ID: {user.labPatientId}</>
                      )}
                    </p>
                  </div>
                  <div
                    className={`d-inline-flex align-items-center justify-content-center ${
                      selectedUser?._id !== user._id ? "bg-secondary" : ""
                    }`}
                    style={{
                      cursor: "pointer",
                      width: "22px",
                      height: "22px",
                      borderRadius: "50%",
                    }}
                    onClick={() => setSelectedUser(user)}
                  >
                    <Form.Check
                      type="radio"
                      name="userSelect"
                      checked={selectedUser?._id === user._id}
                      onChange={() => setSelectedUser(user)}
                    />
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          ) : (
            <Alert variant="warning">
              No users found. Please check your connection or contact support.
            </Alert>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddNewUser}>
            Add New Patient
          </Button>
          <button
            className="btn-purple px-2"
            style={{ paddingTop: "7px", paddingBottom: "7px" }}
            onClick={handleUserSelect}
            disabled={!selectedUser}
          >
            Select Patient
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UserSelectionModal;
